/* eslint-disable */
import { LatLng } from "../models/common/lat-lng";

export class Company {

    id: number;
    placeId: string | null;
    name: string;
    nameLocal?: string | null;
    location: LatLng;
    phoneNumber: string | null;
    crNumber: number;
    taxRegNumber: string | null;
    logo: string | null;
    poBox: number | null;
    websiteURL: string | null;
    address: string;
    addressLocal?: string | null;
    countryId: number;
    emailAddress: string | null;
    defaultContactId: number | null;
    transportationAgencyId: number | null;
    freightForwarderId: number | null;
    enableEnterpriseFeatures?: boolean;
    requireBilingualSingleInvoice?: boolean;

}

export interface OrderControlSettings {
    approvalRequired?: boolean;
    approvalThresholdAmount?: number;
    creditHoldEnabled?: boolean;
    blockOverCreditLimit?: boolean;
    blockOverdue?: boolean;
    overdueDays?: number;
    currencyCode?: string;
    enforceSalesOrderMakerChecker?: boolean;
    enforcePurchaseOrderMakerChecker?: boolean;
    enforceRentalUsageMakerChecker?: boolean;
    enforceInvoiceMakerChecker?: boolean;
    enforceBillMakerChecker?: boolean;
    enforceReceiptMakerChecker?: boolean;
    enforceVoucherMakerChecker?: boolean;
    enforcePettyCashMakerChecker?: boolean;
    enforceDebitNoteMakerChecker?: boolean;
    enforceCreditNoteMakerChecker?: boolean;
    enforceCustomerCreditNoteMakerChecker?: boolean;
    enforceVendorDebitNoteMakerChecker?: boolean;
    enforceJournalEntryMakerChecker?: boolean;
}

export interface DeliveryEvidencePolicy {
    enabled: boolean;
    maxAccuracyMeters: number;
}

export interface SingleInvoiceBilingualPolicy {
    required: boolean;
}
